export default __webpack_public_path__ + "static/media/port_icon.67f144b7.svg";